<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-zatwierdzone' aria-label='Wnioski zatwierdzone'>
        Wnioski zatwierdzone
      </a>
    </li>
    <li>
      {{ serviceType()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert-container [dismissible]='false'></app-alert-container>
    @if (!loading()) {
      <div class="row">
        <div class='col-12'>
          <app-payment-status-checker
            *ngIf='paymentToken'
            (completed)='onPaymentComplete($event)'
            [closableAlert]='false'
            [paymentToken]='paymentToken'
            [canDownload]='false'>
          </app-payment-status-checker>
        </div>
        <div class="col-12">
          <div class='download-actions' *ngIf='application()'>
            <!--            @if (showPaymentBtn()) {-->
            <!--              <a href='#'-->
            <!--                 class='btn btn-secondary'-->
            <!--                 [routerLink]='"../../../zaplac-online/zalaczniki/" + applicationId'-->
            <!--                 title='Przejdź do strony, aby dokonać płatności online'>-->
            <!--                Dokonaj płatności online-->
            <!--              </a>-->
            <!--            }-->
            @if (!!application()?.signedDocument?.id) {
              <a href='#' title='Pobierz PDF' class='btn btn-secondary' (click)='onDownloadApplicationPdf($event)'>
                <i aria-hidden='true' class='fa fa-file-download'></i>
                {{ application()?.service?.url | applicationDownloadPdfActionName }}
              </a>
            }
            <!--            <a-->
            <!--              *ngIf='!!application()?.signedDocument?.id'-->
            <!--              href='#'-->
            <!--              title='Pobierz wniosek podpisany XML'-->
            <!--              class='btn btn-secondary'-->
            <!--              (click)='onDownloadSignedApplication($event)'>-->
            <!--              <i aria-hidden='true' class='fa fa-download'></i>-->
            <!--              Pobierz wniosek podpisany XML-->
            <!--            </a>-->
          </div>
        </div>
      </div>
      <h2>
        {{ serviceType()?.name }}
      </h2>
      <app-w-location-property-in-revitalization-area-preview
        *ngIf="contentUrl === 'ustalenie-numeru-porzadkowego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-w-location-property-in-revitalization-area-preview>
      <app-w-certificate-from-municipal-register-preview
        *ngIf="contentUrl === 'zaswiadczenie-z-gminnej-ewidencji-zabytkow'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-w-certificate-from-municipal-register-preview>
      <app-w-extract-and-draft-mpzp-preview
        *ngIf="contentUrl === 'wypis-i-wyrys-z-mpzp'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-w-extract-and-draft-mpzp-preview>
      <app-w-extract-and-draft-from-study-preview
        *ngIf="contentUrl === 'wypis-i-wyrys-ze-studium'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-w-extract-and-draft-from-study-preview>
      <app-w-determining-planning-fee-before-sale-of-property-preview
        *ngIf="contentUrl === 'ustalenie-oplaty-planistycznej-przed-zbyciem-nieruchomosci'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-w-determining-planning-fee-before-sale-of-property-preview>
      <app-cert-about-conformity-of-use-with-mpzp-preview
        *ngIf="contentUrl === 'zaswiadczenie-z-mpzp'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-cert-about-conformity-of-use-with-mpzp-preview>
      <app-cert-about-conformity-of-study-preview
        *ngIf="contentUrl === 'zaswiadczenie-ze-studium'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-cert-about-conformity-of-study-preview>
      <app-irspa-application-for-the-project-preview
        *ngIf="contentUrl === 'wniosek-do-projektu-aktu-planowania-przestrzennego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-irspa-application-for-the-project-preview>
      <app-irspa-warning-on-the-consulted-draft-preview
        *ngIf="contentUrl === 'uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-irspa-warning-on-the-consulted-draft-preview>
      <app-irspa-amend-the-act-preview
        *ngIf="contentUrl === 'wniosek-o-zmiane-aktu-planowania-przestrzennego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-irspa-amend-the-act-preview>
      <app-irspa-preparation-of-the-act-preview
        *ngIf="contentUrl === 'wniosek-o-sporządzenie-aktu-planowania-przestrzennego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-irspa-preparation-of-the-act-preview>
      <app-opinion-of-conformity-preview
        *ngIf="contentUrl === 'opinia-o-zgodnosci-realizacji-obiektow-z-uchwala-krajobrazowa'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-opinion-of-conformity-preview>
      <app-documents-information-preview
        *ngIf="contentUrl === 'uzupelnienie-dokumentow'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-documents-information-preview>
      <app-general-letter-preview
        *ngIf="contentUrl === 'pismo-ogolne'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-general-letter-preview>
      <app-response-to-call-preview
        *ngIf="contentUrl === 'odpowiedz-na-wezwanie'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-response-to-call-preview>
      <app-lease-of-a-burial-place-preview
        *ngIf="contentUrl === 'wniosek-o-dzierzawe-miejsca-grzebalnego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-lease-of-a-burial-place-preview>
      <app-application-for-a-cemetery-space-preview
        *ngIf="contentUrl === 'wniosek-o-miejsce-na-cmentarzu'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-application-for-a-cemetery-space-preview>
      <app-registration-for-the-sewage-treatment-plant-register-preview
        *ngIf="contentUrl === 'zgloszenie-do-ewidencji-przydomowych-oczyszczalni-sciekow'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-registration-for-the-sewage-treatment-plant-register-preview>
      <app-submitting-an-investor-letter-of-intent-preview
        *ngIf="contentUrl === 'zlozenie-listu-intencyjnego-inwestora'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-submitting-an-investor-letter-of-intent-preview>
      <app-general-application-preview
        *ngIf="contentUrl === 'wniosek-ogolny'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-general-application-preview>
      <app-removal-of-trees-or-shrubs-preview
        *ngIf="contentUrl === 'wniosek-o-wydanie-zezwolenia-na-usuniecie-drzew-lub-krzewow'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-removal-of-trees-or-shrubs-preview>
      <app-municipal-waste-disposal-preview
        *ngIf="contentUrl === 'deklaracja-o-wysokosci-oplaty-za-gospodarowanie-odpadami-komunalnymi'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-municipal-waste-disposal-preview>
      <app-coordinating-traffic-organization-projects-preview
        *ngIf="contentUrl === 'opiniowanie-i-uzgadnianie-projektow-stalej-lub-czasowej-organizacji-ruchu'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-coordinating-traffic-organization-projects-preview>
      <app-decision-on-development-conditions-preview
        *ngIf="contentUrl === 'decyzja-o-warunkach-zabudowy'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-decision-on-development-conditions-preview>
      <app-opinion-of-conformity-of-property-division-mpzp-preview
        *ngIf="contentUrl === 'wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-opinion-of-conformity-of-property-division-mpzp-preview>
      <app-decision-on-determining-the-location-of-a-public-purpose-investment-preview
        *ngIf="contentUrl === 'decyzja-o-ustalenie-lokalizacji-inwestycji-celu-publicznego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]="application()">
      </app-decision-on-determining-the-location-of-a-public-purpose-investment-preview>
    }
    <ng-container *ngIf='!loading()'>
      <br>
      <div class='application-actions'>
        <button
          type='button'
          class='btn btn-secondary' routerLink='../../'>
          <span>
            Wstecz
          </span>
        </button>
        <button
          *ngIf='!!application()?.signedDocument?.id && !application()?.sentAt'
          [disabled]='pending()'
          (click)='sendApplication()'
          type='button'
          class='btn btn-primary'>
          <span>{{ application()?.service?.url | applicationSendActionName }}</span>
        </button>
        @if (!environment.production) {
          <button
            *ngIf='!application()?.signedDocument?.id'
            [disabled]='pending()'
            (click)='fakeSign()'
            type='button'
            class='btn btn-primary'>
            <span>{{ application()?.service?.url | applicationSignActionName }} demo</span>
          </button>
        }
        <button
          *ngIf='!application()?.signedDocument?.id'
          [disabled]='pending()'
          (click)='signApplication()'
          type='button'
          class='btn btn-primary'>
          <span>{{ application()?.service?.url | applicationSignActionName }}</span>
        </button>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
